import { render, staticRenderFns } from "./advantage-form.vue?vue&type=template&id=73479b9e"
import script from "./advantage-form.vue?vue&type=script&lang=js"
export * from "./advantage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports